// extracted by mini-css-extract-plugin
export default {"popper":"yhDd5KTAqKXJmWn3QPpB"};